//Please add the language resource
const bill = {
  rebateAmount:'RebateAmount',
  billMonth:'BillMonth',
  paymentAmount:'PaymentAmount',
  salesAmount:'SalesAmount',
  endingBalance:'EndingBalance',
  beginningBalance:'BeginningBalance',
  confirmStatus:'ConfirmStatus',
  priceDueDate:'PriceDueDate',
  reference:'Reference',
  currencyType:'CurrencyType',
  sapNo:'SapNo',
  salesVoucherType:'salesVoucherType',
  postDate:'PostDate',
  orderAmount:'OrderAmount',
  goldenTaxDate:'GoldenTaxDate',
  goldenTaxNumber:'GoldenTaxNumber',
  billRange:'BillRange',
  financialVoucherNo:'FinancialVoucherNo',
  type:'Type',
  textData:'TextData',
  reasonCode:'reasonCode',
  reasonCodeDesc:'reasonCodeDesc',
  msg:{
  }
};
export default bill



// WEBPACK FOOTER //
// ./src/page/finance/bill/lang/bill.en.js